<template>
  <v-app>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col
            cols="12">
            Vysoký krevní tlak
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.highBloodPressure.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Nízký krevní tlak
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.lowBloodPressure.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Žilní trombóza
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.thrombosis.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.thrombosis.status == '1' ? 'required' : ''"
              v-model="form.thrombosis.value"
              label="Věk v době diagnózy"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.thrombosis.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Plicní embolie
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.pulmonaryEmbolism.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.pulmonaryEmbolism.status == '1' ? 'required' : ''"
              v-model="form.pulmonaryEmbolism.value"
              label="Věk v době diagnózy"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.pulmonaryEmbolism.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Bolest na hrudi
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.chestPain.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Bušení srdce, poruchy srdečního rytmu
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.heartRhythmDisorders.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Srdeční infarkt
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.heartAttack.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.heartAttack.status == '1' ? 'required' : ''"
              v-model="form.heartAttack.value"
              label="Věk v době diagnózy"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.heartAttack.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Cévní mozkovou příhodu
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.stroke.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.stroke.status == '1' ? 'required' : ''"
              v-model="form.stroke.value"
              label="Věk v době diagnózy"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.stroke.status != '1'" />
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheHeartVascular',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        highBloodPressure: {
          status: 0,
          value: 'string'
        },
        lowBloodPressure: {
          status: 0,
          value: 'string'
        },
        thrombosis: {
          status: 0,
          value: ''
        },
        pulmonaryEmbolism: {
          status: 0,
          value: ''
        },
        chestPain: {
          status: 0,
          value: 'string'
        },
        heartRhythmDisorders: {
          status: 0,
          value: 'string'
        },
        heartAttack: {
          status: 0,
          value: ''
        },
        stroke: {
          status: 0,
          value: ''
        }
      }
    };
  },
  computed: {
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        highBloodPressure: {
          status: Number(this.form.highBloodPressure.status),
          value: this.form.highBloodPressure.value
        },
        lowBloodPressure: {
          status: Number(this.form.lowBloodPressure.status),
          value: this.form.lowBloodPressure.value
        },
        thrombosis: {
          status: Number(this.form.thrombosis.status),
          value: this.form.thrombosis.value
        },
        pulmonaryEmbolism: {
          status: Number(this.form.pulmonaryEmbolism.status),
          value: this.form.pulmonaryEmbolism.value
        },
        chestPain: {
          status: Number(this.form.chestPain.status),
          value: this.form.chestPain.value
        },
        heartRhythmDisorders: {
          status: Number(this.form.heartRhythmDisorders.status),
          value: this.form.heartRhythmDisorders.value
        },
        heartAttack: {
          status: Number(this.form.heartAttack.status),
          value: this.form.heartAttack.value
        },
        stroke: {
          status: Number(this.form.stroke.status),
          value: this.form.stroke.value
        }
      });
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/cardiodiseases', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/cardiodiseases', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.form = {
        highBloodPressure: {
          status: String(data.highBloodPressure.status),
          value: 'string'
        },
        lowBloodPressure: {
          status: String(data.lowBloodPressure.status),
          value: 'string'
        },
        thrombosis: {
          status: String(data.thrombosis.status),
          value: data.thrombosis.value
        },
        pulmonaryEmbolism: {
          status: String(data.pulmonaryEmbolism.status),
          value: data.pulmonaryEmbolism.value
        },
        chestPain: {
          status: String(data.chestPain.status),
          value: 'string'
        },
        heartRhythmDisorders: {
          status: String(data.heartRhythmDisorders.status),
          value: 'string'
        },
        heartAttack: {
          status: String(data.heartAttack.status),
          value: data.heartAttack.value
        },
        stroke: {
          status: String(data.stroke.status),
          value: data.stroke.value
        }
      };
    });
  }
};
</script>
